<template>
<div>
    <div class="box mt-5">
      <div class="row">
        <div class="col-md-12 m-3">
          <h3> Documents <ShowHideEye :showSection="showSection" @toggle="showSection = !showSection"/> </h3>
        </div>
      </div>
      <div class="row" v-if="showSection">
        <div class="col-md-12">
          <form class="form wrap form--inline">
            <v-select 
              v-model="selectedDocuments" 
              :options="documentTypes" 
              style="width: 50vh;"
              multiple placeholder="Select document(s)" />
            <button class="button" type="button" v-on:click="download">Download</button>
            <button class="button" type="button" v-on:click="print">Print</button>
            <template v-if="userRole == 1">
              <button class="button" type="button" v-on:click="openEmailToCustomerPopUp('agent')" v-if="bookingForDetails.agent">Email to agent</button>
              <button class="button" type="button" v-on:click="openEmailToCustomerPopUp('customer')" v-else-if="bookingForDetails.customer">Email to customer</button>
              <button class="button" type="button" v-on:click="emailInvoicingDocs">Email booking docs</button>
              <div style="margin-left: 1rem;"> 
                <span><TriggerSMS :bookings="[$route.params.id]" /></span> 
              </div>
              <button v-if="bookingBalance && bookingBalance !== 0" class="button ms-auto" type="button" v-on:click="showConfirmAlert">Email travel docs</button>
              <button v-else class="button ms-auto" type="button" v-on:click="emailTravelDocs">Email travel docs</button>
            </template>
          </form>
        </div>
      </div>
    </div>

    <div class="box" v-if="showSection">
      <div class="row">
        <div class="col-md-12 m-3">
          <h3>Document records</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th>Document</th>
                <th>Created for</th>
                <th>Created at</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="document of bookingDocumentRecords" :key="document.id" >
                <td><a href="javascript:void(0);" v-on:click="documentRecordDownload(document.id)" title="Download this record!"> {{ document.name }}</a></td>
                <td>{{ document.created_for }}</td>
                <td>{{ document.created_at | formatDateTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Email to Customer Modal -->
    <div class="modal-lg" v-if="showEmailCustomerModal == true">
      <EmailCustomerModal 
        @sendEmailToCustomer="sendEmailToCustomer" 
        :mailtemplates="emailTemplates" 
        :selectedDocuments="selectedDocuments"
        :bookingChangeReasons="bookingChangeReasons" 
      />
      <button type="button" class="icon icon--unlink" v-on:click="showEmailCustomerModal = false">Close</button>
    </div>
    <div class="modal__bg" v-if="showEmailCustomerModal == true"></div>
</div>
</template>

<script>
import printJS from 'print-js'
import {mapGetters} from 'vuex'
import EmailCustomerModal from '@/components/EmailCustomerModal.vue'
import ShowHideEye from './ShowHideEye.vue'
import TriggerSMS from "./TriggerSMS.vue";

export default {
  name: 'BookingDocuments',
  components: {
    EmailCustomerModal, ShowHideEye, TriggerSMS
  },
  props : {
    bookingID: Number,
    balanceDue: Number,
    bookingDocumentRecords: Array,
    bookingForDetails:Object,
    bookingPassengers:Array,
    emailTemplates: Array,
    bookingChangeReasons: Array,
    bookingDetails: Object
  },
  data () {
    return {
      documentEmailTo:null,
      selectedDocuments: [],
      showEmailCustomerModal: false,
      showSection: false,
      documentTypes: [
        { label: 'Confirmation', doc: 'invoice' },
        { label: 'ATOL Certificate', doc: 'atol' },
        { label: 'Travel Itinerary', doc: 'airline' },
        { label: 'Airline Check-In Instructions', doc: 'airline-checkin' },
        { label: 'Agent invoice', doc: 'agent-invoice' },
        { label: 'Cancellation invoice', doc: 'cancellation-invoice' }
      ]
    }
  },
  created() {
    this.userRole
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showSection = true
      }
      return user_role
    },
    nonCommissionables() {
      let non_commisionalbe_extras = 0;
      if (this.bookingDetails.non_commissionable_extras.length > 0 ) {
        non_commisionalbe_extras = this.bookingDetails.non_commissionable_extras.reduce((accumulator ,item) => {
          return accumulator += (item.price * item.pivot.qty);
        }, 0)
      }
      return non_commisionalbe_extras;
    },
    agentComission(){
      let bookingAmount = this.bookingDetails.total_due -this.nonCommissionables
      return bookingAmount * (Number(this.bookingDetails.agent_comission_percent) / 100)
    },
    agentBookingVat(){
      return this.agentComission * (Number(this.bookingDetails.booking_vat_percent) / 100)
    },
    bookingBalance() {
      let balance = (this.bookingDetails.total_due )  - this.bookingDetails.paid - (this.agentComission + this.agentBookingVat);
      return (balance > 0) ? Number(balance.toFixed(2)) : 0;
    }
  },
  methods: {
    download() {
      if(!this.selectedDocuments || !this.selectedDocuments.length) {
        this.$notify({
          type: 'warning',
          title: 'Select a document type first!'
        });
        return;
      }
      this.downloadDocuments();
      this.$emit('updateBookingHistory')
    },
    async downloadDocuments() {
      this.$store.dispatch('setLoadStatus')
      try {
        const fetchPromises = this.selectedDocuments.map((document) => {
          return fetch(this.$api + 'bookings/' + this.bookingID + '/documents/' + document.doc + '?type=download', {
            headers: {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token'),
            },
          })
          .then((res) => res.json())
          .then((response) => {
            if (response.success === true) {
              const downloadUrl = this.$api + 'bookings/document/' + response.file + '/download';
              window.open(downloadUrl, '_blank'); // Open the URL in a new window for download
            }
          });
        });

        await Promise.all(fetchPromises); // Wait for all fetch requests to complete

        // All fetch requests have completed
        this.$store.dispatch('setLoadStatus')
      } catch (error) {
        console.error('Error:', error);
        this.$store.dispatch('setLoadStatus')
      }
    },
    documentRecordDownload(id) {
      // alert(id);
      this.$store.dispatch('setLoadStatus')
      // for (let document of this.selectedDocuments) {
        fetch(this.$api + 'bookings/' + this.bookingID + '/document-records/' + id , {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          if(response.success == true) {
            window.open(this.$api + 'bookings/document-record/' + id + '/download', '_blank');
          }
        })
      // }
    },
    print() {
      if (!this.bookingForDetails.agent && !this.bookingForDetails.customer) {

        this.$notify({
          type: 'error',
          title: 'This booking does not have any agent or customer. Plese select anyone.'
        });
        return;

      } else if(!this.selectedDocuments || !this.selectedDocuments.length) {
        this.$notify({
          type: 'warning',
          title: 'Select a document type first!'
        });
        return;
      } 

      this.$store.dispatch('setLoadStatus')

      for (let document of this.selectedDocuments) {

        if(document.doc == 'agent-invoice' && this.bookingForDetails.agent == null ){
            this.$notify({
              type: 'warning',
              title: 'Please select an agent for agent invoice'
            });
            
            this.$store.dispatch('setLoadStatus')
          continue ;
        }else{
          
          fetch(this.$api + 'bookings/' + this.bookingID + '/documents/' + document.doc + '?type=print', {
            headers: {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          })
          .then(res => res.json())
          .then(response => {
            this.$store.dispatch('setLoadStatus')
            if (response.success == true) printJS(this.$api + 'bookings/document/' + response.file);
            this.$emit('updateBookingHistory')
          })
        }
      }
    },
    emailInvoicingDocs() {
      if(!this.bookingForDetails.agent && !this.bookingForDetails.customer){
        this.$notify({
          type: 'error',
          title: 'This booking does not have any agent or customer. Plese select anyone.'
        });
        return;
      }

      let confirmMessageFor = (this.bookingForDetails.agent) ? 'agent' : 'customer';

      if (confirmMessageFor == 'customer') {
        if (!this.bookingDetails.customer.meta_data) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this customer'
          });
          return;
        }
        if (this.bookingDetails.customer.meta_data.email_addresses.length > 0 && !this.bookingDetails.customer.meta_data.email_addresses[0].email) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this customer'
          });
          return;
        }  
      }

      if (confirmMessageFor == 'agent') {
        if (!this.bookingDetails.agent.email) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this agent'
          });
          return;
        }
      }

      if (confirm(`Are you sure you want to send email to ${confirmMessageFor}?`)) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'bookings/' + this.$route.params.id + '/documents/send-email/invoicing-docs?type=email_customer', {
          method: 'POST',
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
            this.$emit('updateBookingHistory')
          }
          this.$store.dispatch('setLoadStatus')
        })
      }
    },

    emailTravelDocs() {

      let confirmMessageFor = (this.bookingForDetails.agent) ? 'agent' : 'customer';

      this.$dialog
      .confirm(`Are you sure you want to send email to ${confirmMessageFor} ?`)
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'bookings/' + this.$route.params.id + '/documents/email-travel-document?type=email_customer', {
          method: 'POST',
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$emit('updateBookingHistory')
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus')
        })
      })
      .catch(() => {
        console.log('Clicked on cancel');
      });
    },
    showConfirmAlert() {
      // Check if Agent exists
      if (!this.bookingForDetails.agent && !this.bookingForDetails.customer) {
        this.$notify({
          type: 'error',
          title: 'Please select customer or an agent for this booking'
        });

      }else{
        let confirmMessageFor = (this.bookingForDetails.agent) ? 'agent' : 'customer';

        if (confirmMessageFor == 'customer') {
          if (!this.bookingDetails.customer.meta_data) {
            this.$notify({
              type: 'error',
              title: 'Please provide an email address for this customer'
            });
            return;
          }
          if (this.bookingDetails.customer.meta_data.email_addresses.length > 0 && !this.bookingDetails.customer.meta_data.email_addresses[0].email) {
            this.$notify({
              type: 'error',
              title: 'Please provide an email address for this customer'
            });
            return;
          }  
        }

        if (confirmMessageFor == 'agent') {
          if (!this.bookingDetails.agent.email) {
            this.$notify({
              type: 'error',
              title: 'Please provide an email address for this agent'
            });
            return;
          }
        }
        
        this.$dialog
        .confirm(`This booking has an outstanding balance to pay. Are you sure you want to send travel documents to the ${confirmMessageFor} ?`)
        .then(() => {
          this.emailTravelDocs();
        })
        .catch(() => {
          console.log('Clicked on cancel');
        });
      }
      
    },
    openEmailToCustomerPopUp(type) {
      if (type == 'customer') {
        if (!this.bookingDetails.customer.meta_data) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this customers'
          });
          return;
        }
        if (this.bookingDetails.customer.meta_data.email_addresses.length > 0 && !this.bookingDetails.customer.meta_data.email_addresses[0].email) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this customer present'
          });
          return;
        }  
      }

      if (type == 'agent') {
        if (!this.bookingDetails.agent.email) {
          this.$notify({
            type: 'error',
            title: 'Please provide an email address for this agent'
          });
          return;
        }
      }

      // Check for the Passenger existence for particular selected document
      let noDocArray = [];
      let This = this
      let requiredPassengers=['invoice','airline'];

      if(this.bookingPassengers.length == 0 ){
        this.selectedDocuments.forEach((document) => {
          let docExists = requiredPassengers.find(element => element == document.doc)
          if (docExists) {
            noDocArray.push(document.label)
          }
        })

        if (noDocArray.length > 0 ) {
          this.$notify({
            type: 'warning',
            title: `No Passengers available, So ${noDocArray.join(" , ") } will no be generated and sent over the email.`
          });
        }
      }

      this.documentEmailTo = type
      this.showEmailCustomerModal = true
      return
      
    },
    sendEmailToCustomer(template,intimateCustomer = false, selectedReasons = []) {

        let selectedDocs = [];
        
        if (this.selectedDocuments.length > 0 ) {
          this.selectedDocuments.forEach((element) => selectedDocs.push(element.doc))
        }
        
        let bodyParams =  {
          email_to: this.documentEmailTo,
          template: template,
          email_documents: selectedDocs,
          intimate_customer: (intimateCustomer) ? 'yes' : 'no',
          intimate_customer_reasons:selectedReasons,
        }

        if (selectedDocs.length == 0 ) {
          this.$swal({
            title: "Are you sure?",
            text: "No Documents attached. Do you wish to conitnue ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Continue!"
          }).then((result) => {
            if(result.isConfirmed) {
              this.triggerEmailToCustomer(bodyParams)
            }
          })
        }else{
          this.triggerEmailToCustomer(bodyParams)
        }
    },
    triggerEmailToCustomer(body_params) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'bookings/' + this.$route.params.id + '/send-email-customer', {
          method: 'POST',
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
          body: JSON.stringify(body_params)
        })
        .then(res => res.json())
        .then(response => {
          if(response.status) {
            
            this.$notify({
              type: 'success',
              title: response.message
            });

            this.documentEmailTo = null
            this.showEmailCustomerModal = false
            this.$emit("get-booking");
            this.$emit("updateBookingHistory");
            
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus')
        })
    }
  }
}
</script>

